import Link from 'next/link';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { cn } from '@/utils/cn';

interface VacancyTileProps {
    title: string;
    href: string;
    viewLabel: string;
}

export default function VacancyTile({ title, href, viewLabel }: VacancyTileProps) {
    return (
        <Link
            href={href}
            className={cn(
                'group relative flex w-full items-center justify-between gap-4',
                'bg-haug-lila-100 px-6 py-4 font-neue-haas',
                'text-haug-ivory-100',
                'transition-colors hover:bg-haug-lila-200',
                'focus:outline-none focus:ring-2 focus:ring-haug-coral-100'
            )}
        >
            <h3 className="font-bold text-xl lg:text-2xl">{title}</h3>
            <span className="flex shrink-0 items-center gap-1 text-sm font-semibold uppercase tracking-wide">
                {viewLabel}
                <ChevronRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </span>
        </Link>
    );
}
